<template>
  <!-- Logo section -->
  <div
    id="sidebarLogoTooltipAnchor"
    v-tooltip.right="{
      value: 'Open sidebar, shortcut [',
      hideDelay: 100,
      showDelay: 1000,
    }"
    class="justify-center mt-3 mb-4 md:mb-0 hidden md:flex relative flex-col items-center h-14"
  >
    <!-- Toggle Button - shows on hover when secondary nav closed -->
    <div
      :class="!showCollapseButton ? 'opacity-0' : 'opacity-100'"
      class="absolute inset-0 w-full pointer-events-none flex items-center justify-center transition-opacity duration-100"
    >
      <SecondaryNavToggleButton />
    </div>

    <!-- Logo - always shows, hides on hover when secondary nav closed -->
    <button
      id="logo-link"
      aria-label="Application logo"
      class="absolute inset-0 cursor-pointer w-full flex flex-col pointer-events-none items-center justify-center hover:bg-surface transition-opacity duration-100"
      :class="showCollapseButton ? 'opacity-0' : 'opacity-100'"
      data-test-id="sidebar-logo-link"
    >
      <Logo class="size-6 text-brand" />
    </button>
  </div>
</template>

<script setup lang="ts">
import Logo from 'assets/images/logo.svg'
import SecondaryNavToggleButton from './SecondaryNavToggleButton.vue'

interface Props {
  showCollapseButton: boolean
}

defineProps<Props>()
</script>
